import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'

export interface TipoUsr{
    id:number,
    tipo:string
}


@Injectable({
  providedIn: 'root'
})
export class instiUser {  
   private authorization: string = '';
   private user_data:any=null;
   private allow_tipo:number[]=[1,2,3,4];
   //1 - desenv  2 - admin  3 - tecnico  4 - comum
   private tipos:TipoUsr[]=[{'id':1,'tipo':'desenv'},
                            {'id':2,'tipo':'admin'},    
                            {'id':3,'tipo':'tecnico'},
                            {'id':4,'tipo':'comun'}
   ];    
  constructor(
         
            ) { }  
   
    private processData(dados, response?, sucess_func?){
        if(!this.hasData()){ 
            this.setAuthorization(null);
            if(typeof sucess_func === 'function'){
                sucess_func(response);
            }
            return this; 
        }
        var ud=dados;
        this.setAuthorization(ud.hasOwnProperty('api_authorizations')? ud.api_authorizations : null);    
        if(typeof sucess_func === 'function'){
            sucess_func(response);
        }
        return this  
    }
      private setAuthorization(value){ 
        this.authorization=value; 
        localStorage.setItem('insti_authorization', value);
        return this;
      }
      getAuthorization(){ 
        var b=this.authorization ? this.authorization : this.getAutorizationFromStorage();
        try {
            return (JSON.parse(b)) ? b : '';
        } catch (error) {
        }
        return b;
     }
     getAutorizationFromStorage(){
        var a=localStorage.getItem('insti_authorization');
        return a;
    }
    setData(value, response?, sucess_func?){ 

        var d=!value ? {} : value;
        this.user_data=Object.keys(d).length==0? null : (d.hasOwnProperty('user_data') ? d.user_data : null);
        localStorage.setItem('insti_user_data', JSON.stringify(this.user_data)); 
        return this.processData(d, response, sucess_func);
    }
    setAlterarSenha(value){
        let user = {};
        user['user_data'] = this.getDataFromStorage();
        user['user_data'].alterarSenha = value;
        user['api_authorizations'] = this.getAuthorization();
        this.setData(user);
    }   
     getDataFromStorage(){
        var a=JSON.parse(localStorage.getItem('insti_user_data')); 
        return a;
     }
     getData(){ 
        var c= this.user_data ? this.user_data : this.getDataFromStorage() ;
        return c;
    }
    hasData():boolean{
        let d=this.getData(); 
        if(!d){ return false;}
        return Object.keys(d).length==0? false : true;
    }
    isLogged():boolean{ return this.hasData();}

    
    alterarSenha():boolean{
        let d=this.getData();
        if(!d){ return false;}
        if(!d.hasOwnProperty('alterarSenha')){            
            return false;
        }
        return d.alterarSenha == 1 ? true : false;
    }
    hasProperty(property:string){
        if(!this.hasData()){
            return false;
        }
        let a=this.getData();
       return a.hasOwnProperty(property);
    }
    getField(field_name:string){
        if(!this.hasProperty(field_name)){
            return null;
        } 
        let a=this.getData();
       return a[field_name];
    }
    getStatus(){ return this.getField('status');}
    getTipos(){ return this.tipos;}
    getTipo(){ return this.getField('tipo');}
    isTipo(p_tipo:string, p_tipo_id?:number){
        let l_tipo_id = !p_tipo_id ? this.getTipo() : p_tipo_id;
        let l_tipo = p_tipo;
        let tem=this.getTipos().filter(function(atual){
            return atual.id==l_tipo_id && atual.tipo == l_tipo;
        }); 
        return tem.length? true: false;
    }
    getNome(){ return this.getField('nome');}
    getEmail(){ return this.getField('email');}
    getMatricula(){ return this.getField('matricula');}
    //getIsAdmin(){ return this.getTipo()==;}
    
    
}

